module.exports = __webpack_public_path__ + "media/bootstrap-icons/brush-fill-b21208b5.svg";